<template>
	<svg class="w-auto h-8 fill-current sm:h-10 filter drop-shadow-lg" viewBox="0 0 79 80" xmlns="http://www.w3.org/2000/svg">
		<path d="M59.8107 0.554733L28.6947 46.1334L14.9172 34.8241L0.531738 52.3468L33.4493 79.3734L78.532 13.3334L59.8107 0.554733Z" />
	</svg>
</template>

<script>
export default {
	name: 'IconTick',
}
</script>
